import { render } from "./SerieBlocks.vue?vue&type=template&id=0b59b69e"
import script from "./SerieBlocks.vue?vue&type=script&lang=js"
export * from "./SerieBlocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__